import { PauseCircle, PlayCircle } from "react-feather";
import tw from 'twin.macro'
import React, { useRef, useState } from "react";

export default function VideoPlayer({ 
  videoSrc, 
  playButtonLocation, 
  pauseButtonLocation,
  playButtonSize = { width: "170", height: "170" },
  pauseButtonSize = { width: "70", height: "70" },
  autoPlay = false,
  videoPlacement,
  centerButtons = true
}) {
    const [control, setControl] = useState(!autoPlay)
    const [isMuted, setIsMuted] = useState(autoPlay)
    const play = useRef(null)

    const playVidHandler = () => {
      setControl(false)
      setIsMuted(false)
      if (play.current) {
        play.current.muted = false
        play.current.play()
      }
    }

    const pauseVidHandler = () => {
      setControl(true)
      setIsMuted(false)
      if (play.current) {
        play.current.pause()
      }
    }
    
    const defaultPlayButtonStyles = tw`absolute top-1/2 left-1/2`
    const defaultPauseButtonStyles = tw`absolute bottom-0 right-0`

    return <div tw="h-full w-full">
      <div tw="h-full w-full relative">
        <video 
          ref={play} 
          css={[
              tw`w-full h-full`,
              videoPlacement || tw`object-cover`
            ]}
          loop 
          muted={isMuted}
          playsInline
          autoPlay={autoPlay}
        >
          <source src={videoSrc} type="video/mp4"></source>
        </video>
        {control ? (
          <div 
            css={[
              tw`hover:cursor-pointer z-20`,
              playButtonLocation || defaultPlayButtonStyles
            ]}
            style={centerButtons ? { transform: 'translate(-50%, -50%)' } : null}
          >           
            <PlayCircle
              onClick={playVidHandler}
              color="#fff"
              width={playButtonSize.width}
              height={playButtonSize.height}
              opacity="0.6"
            />
          </div>
        ) : (
          <div 
            css={[
              tw`hover:cursor-pointer`,
              pauseButtonLocation || defaultPauseButtonStyles
            ]}
            style={centerButtons ? { transform: 'translate(-50%, -50%)' } : null}
          >
            <PauseCircle
              onClick={pauseVidHandler}
              color="#9999"
              width={pauseButtonSize.width}
              height={pauseButtonSize.height}
              opacity="0.6"
            />
          </div>
        )}
      </div>
    </div>
}